import { AnyAction, createAsyncThunk, createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { journalClient } from '../../../api/client';
import { getPagination, keysToId } from '../../../helpers/sliceHelper';
import { RootState } from '../../store';
import { JournalEventsType, JournalListQuery, JournalListType, JournalState } from './journalInterface';

const eventsAdapter = createEntityAdapter<JournalListType>();

export const listJournal = createAsyncThunk('journal/listJournal', async (query: JournalListQuery) =>
  journalClient.listJournal(
    query.entityType,
    query.entityId,
    query.action,
    query.user,
    query.search,
    query.occurredBegin,
    query.occurredEnd,
    query.organizationId,
    query.sortBy,
    query.offset,
    query.limit,
  ),
);

export const journalSlice = createSlice({
  name: 'journal',
  initialState: {
    events: eventsAdapter.getInitialState(),
  } as JournalState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listJournal.pending, (state: JournalState) => {
      state.error = undefined;
      state.fetching = { ...(state.fetching || {}), listJournal: true };
    });
    builder.addCase(listJournal.fulfilled, (state: JournalState, action: AnyAction) => {
      state.fetching = { ...state.fetching, listJournal: false };
      if (action.payload.data?.result) {
        eventsAdapter.upsertOne(state.events, { id: keysToId(action.meta.arg), ...action.payload.data });
      }
    });
    builder.addCase(listJournal.rejected, (state: JournalState, action: AnyAction) => {
      state.error = action.error;
      state.fetching = { ...state.fetching, listJournal: false };
    });
  },
});

export const { selectById: selectJournalEventsById } = eventsAdapter.getSelectors((state: RootState) => state.journal.events);

const selectJournalEvents = createSelector([selectJournalEventsById], (events) => ({
  pagination: getPagination(events),
  result: events?.result,
}));

export const getJournalEvents =
  (keys: JournalListQuery) =>
  (state: RootState): JournalEventsType =>
    selectJournalEvents(state, keysToId(keys));

export const journalEventsFetching = (state: RootState): boolean => state.journal.fetching?.listJournal !== false;

export default journalSlice.reducer;
